module.exports = __webpack_public_path__ + "img/Submarine.feb8fabf.png";